var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDownload2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1817_26899",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1817_26899)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.16683 16.666H15.8335C16.0696 16.666 16.2675 16.7459 16.4272 16.9056C16.587 17.0653 16.6668 17.2632 16.6668 17.4993C16.6668 17.7355 16.587 17.9334 16.4272 18.0931C16.2675 18.2528 16.0696 18.3327 15.8335 18.3327H4.16683C3.93072 18.3327 3.7328 18.2528 3.57308 18.0931C3.41336 17.9334 3.3335 17.7355 3.3335 17.4993C3.3335 17.2632 3.41336 17.0653 3.57308 16.9056C3.7328 16.7459 3.93072 16.666 4.16683 16.666ZM10.0002 14.4785C9.87516 14.4785 9.75363 14.4507 9.63558 14.3952C9.51752 14.3396 9.41683 14.2563 9.3335 14.1452L5.2085 8.85352C5.00016 8.57574 4.97239 8.2806 5.12516 7.9681C5.27794 7.6556 5.52794 7.49935 5.87516 7.49935H7.50016V2.49935C7.50016 2.26324 7.58002 2.06532 7.73975 1.9056C7.89947 1.74588 8.09738 1.66602 8.3335 1.66602H11.6668C11.9029 1.66602 12.1009 1.74588 12.2606 1.9056C12.4203 2.06532 12.5002 2.26324 12.5002 2.49935V7.49935H14.1252C14.4724 7.49935 14.7224 7.6556 14.8752 7.9681C15.0279 8.2806 15.0002 8.57574 14.7918 8.85352L10.6668 14.1452C10.5835 14.2563 10.4828 14.3396 10.3647 14.3952C10.2467 14.4507 10.1252 14.4785 10.0002 14.4785Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownload2);
export default __webpack_public_path__ + "static/media/icon_download_2.4e71b184345f65c4ed97e36417edd405.svg";
export { ForwardRef as ReactComponent };